// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2cb0g","item":"PaymentsMobile_item__EZ0zz","label":"PaymentsMobile_label__e9ClX","amount":"PaymentsMobile_amount__OGhC2"};